import { GreenroomState } from '../types/types';

export const selectBlpSession = (state: GreenroomState) => state.SessionReducer.blpSession;

export const selectOpentokSession = (state: GreenroomState) => (state.OpenTokReducer.opentokSession
	? state.OpenTokReducer.opentokSession
	: state.SessionReducer.meeting?.opentok_session ?? null);
